import React, { createContext, useContext, useSyncExternalStore } from 'react';
import { liveFeed } from '../../utils/liveFeed';

const LiveFeedContext = createContext(null);

const useSnapshot = () =>
  useSyncExternalStore(liveFeed.subscribe, liveFeed.getSnapshot, liveFeed.getSnapshot);

export const LiveFeedProvider = ({ children }) => {
  const snapshot = useSnapshot();
  return <LiveFeedContext.Provider value={snapshot}>{children}</LiveFeedContext.Provider>;
};

export const useLiveFeed = (selector) => {
  const snapshot = useContext(LiveFeedContext);
  // Defensive fallback: if a consumer renders outside the provider (e.g. SSR stub),
  // fall back to the store's current snapshot so values still appear.
  const resolved = snapshot ?? liveFeed.getSnapshot();
  return selector ? selector(resolved) : resolved;
};
